export const api_key_features = {
  chat: {
    text: 'Chat',
    value: 'chat',
  },
  keyword: {
    text: 'Keyword',
    value: 'keyword',
  },
  summary: {
    text: 'Summary',
    value: 'summary',
  },
  transcription: {
    text: 'Transcription',
    value: 'transcription',
  },
  transcription_and_segmentation: {
    text: 'Transcription And Segmentation',
    value: 'transcription_and_segmentation',
  },
  segmentation: {
    text: 'Segmentation',
    value: 'segmentation',
  },
  client_auth: {
    text: 'Client Auth',
    value: 'client_auth',
  },
  openai_sdk: {
    text: 'OpenAI SDK',
    value: 'openai_sdk',
  },
}